import { createTheme } from "@mui/material";

const lightPalette = {
  mode: "light",
  primary: {
    main: '#1F6EB9',
    light: '#f0f4fb',
  },
  secondary: {
    main: '#E2F0FE',
    light: '#F8F9FA',
  },
  background: {
    default: '#f0f4fb',
    paper: '#FFFFFF',
    disabled: '#d9d9d9',
  },
  text: {
    main: '#000000',
    primary: '#000000',
    secondary: '#000000',
  },
  border: {
    primary: '#9797A91F',
    secondary: '#95A5A6',
  },
  button: {
    primary: '#1668dc',
    secondary: '#1668dc'
  },
  tableBg: {
    primary: '#FFFFFF',
    secondary: '#FFFFFF'
  },
  drawerText: {
    primary: '#676767',
    secondary: '#FFFFFF'
  }
};

const darkPalette = {
  mode: "dark",
  primary: {
    main: '#1F6EB9',
    light: '#0D2F4F',
  },
  background: {
    default: '#243E57',
    paper: '#001529',
    disabled: '#d9d9d9',
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#FFFFFF',
  },
  border: {
    primary: '#9797A91F',
    secondary: '#000',
  },
  secondary: {
    main: '#0D2F4F',
    light: '#192C3E',
  },
  button: {
    primary: '#1668dc',
    secondary: '#1668dc'
  },
  tableBg: {
    primary: '#002140',
    secondary: '#1e1e1e',
  },
  drawerText: {
    primary: '#FFFFFF',
    secondary: '#FFFFFF'
  }
};


export const getTheme = (mode) => {
  return createTheme({
    palette: mode === 'dark' ? darkPalette : lightPalette,
  });
};
